import React from "react";
// import backgroundimg from "../assets/service-banner.jpg";
import "./sub.css";
import { Helmet } from "react-helmet";
import contactConfig from "../confi";
function Careers() {
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  return (
    <>
      {/* ---------------- SEO Helmet ---------------- */}
      <Helmet>
        <title>Need Job in Ahmedabad, Gujarat? Apply Now - JP Home Services</title>
        <meta
          name="description"
          content="Need job opportunity as a maid, cook, babysitter, driver, or patient care staff in Ahmedabad & Gujarat? Apply at JP Home Services or call +918780438907."
        />
        <meta
          name="keywords"
          content="need job, JP Home Services jobs, job openings, maid jobs, cook jobs, babysitter jobs, driver jobs, patient care jobs"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jphomeservice.in/need-job" />

        {/* Open Graph */}
        <meta property="og:title" content="Need Job in Ahmedabad, Gujarat? Apply Now - JP Home Services" />
        <meta
          property="og:description"
          content="Need job opportunity as a maid, cook, babysitter, driver, or patient care staff in Ahmedabad & Gujarat? Apply at JP Home Services or call +918780438907."
        />
        <meta property="og:image" content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jphomeservice.in/need-job" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Need Job in Ahmedabad, Gujarat? Apply Now - JP Home Services" />
        <meta
          name="twitter:description"
          content="Need job opportunity as a maid, cook, babysitter, driver, or patient care staff in Ahmedabad & Gujarat? Apply at JP Home Services or call +918780438907."
        />
        <meta name="twitter:image" content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "JP Home Services",
      "url": "https://jphomeservice.in",
      "logo": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
      "sameAs": [
        "https://www.facebook.com/jphomeservice.in/",
        "https://www.instagram.com/jp_home_service/"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+919327365056",
        "contactType": "HR Department"
      },
      "department": {
        "@type": "Organization",
        "name": "Recruitment Department",
        "url": "https://jphomeservice.in/need-job"
      },
      "jobPosting": {
        "@type": "JobPosting",
        "title": "Multiple Job Openings at JP Home Services",
        "description": "JP Home Services is hiring reliable domestic staff including maids, cooks, babysitters, and patient care assistants.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "JP Home Services",
          "sameAs": "https://jphomeservice.in"
        },
        "employmentType": "Full-time",
        "datePosted": "${new Date().toISOString().split('T')[0]}",
        "validThrough": "2026-12-31",
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Ahmedabad",
            "addressRegion": "Gujarat",
            "addressCountry": "IN"
          }
        }
      }
    }
    `}
        </script>
      </Helmet>


      {/* ---------------- Banner Section ---------------- */}
      <section className="about-hero">
        <div className="hero-content1">
          <h1>Need Job</h1>
          <p className="hero-subtitle1">
            Your Trusted Partner in Home Care Services
          </p>
        </div>
      </section>
      <div className="floating-contact-icons">
        <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
          </svg>
        </div>
        <div
          className="contact-icon call-icon"
          onClick={handleCall}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
            <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
          </svg>
        </div>
      </div>

      {/* ---------------- Careers Content ---------------- */}
      <div className="career">
        <div className="career-content">
          <h1 className="career-heading">Kickstart Your Career with Us</h1>
          <p className="sub-text">
            At <span className="org-name">JP Home Services</span>, we’re not just providing help — we’re improving lives. Whether you need a reliable maid, caring babysitter, skilled cook, or professional patient caretaker, we offer trusted and verified home service professionals to make your daily life easier and stress-free.
          </p>
          <div className="career-row">
            <h2 className="position-heading">Open Positions</h2>
            <div className="career-columns">
              <div className="career-col">
                <h3 className="position">Full-time Roles</h3>
                <p className="position-text">
                  Join our dynamic team of developers solving complex problems
                  using modern technologies and frameworks.
                </p>
                <a href="https://forms.gle/mh2p6yLm7rWSMbwW8">
                  <button className="career-btn">
                    Apply For Full-time Job
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
